import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/translations';
// components
import SvgColor from 'src/components/svg-color';
// hooks
import { useAuthContext } from 'src/auth/hooks';
// enums
import { AccessRoleEnum } from 'src/enums';
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  explore: icon('ic_explore_twotone'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const { t } = useLocales();
  const { user } = useAuthContext();

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: t('overview'),
        items: [
          {
            title: t('app'),
            path: paths.dashboard.root,
            icon: ICONS.dashboard,
          },
          ...(user?.role === AccessRoleEnum.ADMINSTRATOR
            ? [
                {
                  title: t('user'),
                  path: paths.dashboard.user.list,
                  icon: ICONS.user,
                },
              ]
            : []),
          {
            title: t('levels'),
            path: paths.dashboard.level.list,
            icon: ICONS.tour,
          },
          // TODO: uncomment in the next release
          // {
          //   title: t('gamification'),
          //   path: paths.dashboard.quest.root,
          //   icon: ICONS.explore,
          //   children: [{ title: t('quest'), path: paths.dashboard.quest.list }],
          // },

          ...(user?.role !== AccessRoleEnum.APIKEY
            ? [
                {
                  title: t('games'),
                  path: paths.dashboard.games.root,
                  icon: ICONS.label,
                  children: [
                    { title: t('casinoGames'), path: paths.dashboard.games.list },
                    { title: t('vendors'), path: paths.dashboard.vendors.list },
                    { title: t('categories'), path: paths.dashboard.categories.list },
                    { title: t('lobby'), path: paths.dashboard.lobbyBlocks.list },
                  ],
                },
              ]
            : []),

          // try to unify bonuses on games
          // {
          //   title: t('bonusEngine'),
          //   path: paths.dashboard.bonus.list,
          //   icon: ICONS.gift,
          // },
        ],
      },
    ],
    [t]
  );

  return data;
}
